import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const accountInformation: any = createAsyncThunk<any>(
	'accountInformation',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/tenant-portal/configurations',
				{
					params: data
				}
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addShipingLabel: any = createAsyncThunk<any>(
	'addShipingLabel',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/tenant-portal/configurations',
				data
			);
			return response.data;
		} catch (error: any) {
			console.log(error?.response?.data, 7171);
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateAppSetting: any = createAsyncThunk<any>(
	'updateAppSetting',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/tenant-portal/configurations',
				data
			);
			return response.data;
		} catch (error: any) {
			console.log(error?.response?.data, 7171);
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addSingleOrGropTax: any = createAsyncThunk<any>(
	'addSingleOrGropTax',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/configuration/tax',
				data
			);
			return response.data;
		} catch (error: any) {
			console.log(error?.response?.data, 7171);
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editSingleOrGropTax: any = createAsyncThunk<any>(
	'editSingleOrGropTax',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/configuration/tax',
				data
			);
			return response.data;
		} catch (error: any) {
			console.log(error?.response?.data, 7171);
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getTaxInfo: any = createAsyncThunk<any>(
	'getTaxInfo',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/configuration/master-tax',
				{
					params: data
				}
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addTaxInfo: any = createAsyncThunk<any>(
	'addTaxInfo',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/configuration/master-tax',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getTaxPayList: any = createAsyncThunk<any>(
	'getTaxPayList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/configuration/tax',
				{
					params: data
				}
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteTax: any = createAsyncThunk<any>(
	'deleteTax',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/productService/configuration/tax',
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			console.log(error?.response?.data, 7171);
			return rejectWithValue(error?.response?.data);
		}
	}
);
